<template>
  <div id="DebtNoteUnitDetailReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Debt Note Unit Detail</div>
          <div class="web-action-btn btn-groups text-right">
                <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                    <i class="fp-export"></i> Export
                </a>
            </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'debtNoteUnitDetailReport'" ref="filterComponent" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'debtNoteUnitDetailReport'" :position="'top'">
                </custom-pagination>
                <vue-good-table
                  mode="remote"
                  title="Debt Note Unit Detail Report"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :paginationOptions="{
                      enabled: false,
                      position: 'both',
                      perPage: perPage,
                      dropdownAllowAll: false,
                      setCurrentPage:listCurrentPage,
                      perPageDropdown:dropDownPerPage,
                  }"
                  :search-options="{
                  enabled: false,
                  }"

                  >
                </vue-good-table>
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "DebtNoteUnitDetailReport",
  metaInfo() {
            return {title: "Debt Note Unit Detail | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    action: 'list',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns: [
                {
                    label: 'Unit Number',
                    field: 'unit_no',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true

                },
                {
                    label: 'Interest Rate',
                    field: 'interest_rate',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: true,
                },
                {
                    label: 'Reference',
                    field: 'reference',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true

                },
                {
                    label: 'Financier',
                    field: 'financier',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true

                },
                {
                    label: 'Start Date',
                    field: 'start_date',
                    fpFieldType:"custom_date",
                    hidden:false,
                    filterable: true

                },
                {
                    label: 'Schedule Payout Date',
                    field: 'sch_end_date',
                    fpFieldType:"custom_date",
                    hidden:false,
                    filterable: true

                },
                {
                    label: 'Next Scheduled Date',
                    field: 'nxt_sch_date',
                    fpFieldType:"custom_date",
                    hidden:false,
                    filterable: true

                },
                {
                    label: 'Next Payment Amount',
                    field: 'nxt_payment_amt',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: true


                },
                {
                    label: 'Outstanding Principal',
                    field: 'outstanding_principal',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: false,
                    sortable:false
                },
                {
                    label: 'Outstanding Interest',
                    field: 'outstanding_interest',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: false,
                    sortable: false,

                },
                {
                    label: 'Final Payment Amount',
                    field: 'final_pay_amt',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: true


                },
                {
                    label: 'Balloon Payment',
                    field: 'balloon_pay',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: false,
                    sortable : false,
                },
                {
                    label: 'Overdue P and I',
                    field: 'overdue_pi',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: false,
                    sortable : false,
                },
                {
                    label: '0-30 Day P and I',
                    field: 'overdue_pi_1',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: false,
                    sortable : false,
                },
                {
                    label: '31-60 Day P and I',
                    field: 'overdue_pi_2',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: false,
                    sortable : false,
                },
                {
                    label: '61-90 Day P and I',
                    field: 'overdue_pi_3',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: false,
                    sortable : false,
                },
                {
                    label: '91-120 Day P and I',
                    field: 'overdue_pi_4',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: false,
                    sortable : false,
                },
                {
                    label: '+ 120 Day P and I',
                    field: 'overdue_pi_5',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: false,
                    sortable : false,
                },
                {
                    label: 'Make',
                    field: 'make',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true

                },
                {
                    label: 'Model',
                    field: 'model',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true

                },
                {
                    label: 'Year',
                    field: 'year',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true

                },
                {
                    label: 'Equip Type',
                    field: 'equip_type',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true

                },
                {
                    label: 'Pool',
                    field: 'pool',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true

                },
                {
                    label: 'Facility',
                    field: 'location',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true

                },
                {
                    label: 'Serial Number',
                    field: 'serial_number',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true

                },
                {
                    label: 'Unit Description',
                    field: 'unit_desp',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true

                },
                {
                    label: 'Payment Type',
                    field: 'pay_type',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions:{
                      filterDropdownItems: ['Lease Payment(L)','Principle and Interest(B)','Principle(F)'],
                    }

                },
                {
                    label: 'Current Reading',
                    field: 'curr_read',
                    fpFieldType:"integer",
                    hidden:false,
                    // type:'number',
                    filterable: true,
                },
                {
                    label: 'UOM',
                    field: 'uom',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: false,
                    sortable: false,

                },
                {
                    label: 'Measurement Date',
                    field: 'measure_date',
                    fpFieldType:"custom_date",
                    hidden:false,
                    filterable: true

                },
                {
                    label: 'Customer Name',
                    field: 'cust_name',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true

                },
                {
                    label: 'Customer Number',
                    field: 'cust_number',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true

                },
                {
                    label: 'Agmt Type',
                    field: 'agreement_type',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"option",
                    filterOptions:{
                      filterDropdownItems:["RC","LC"]
                    },
                    sortable : false
                },
                {
                    label: 'Agmt Nbr',
                    field: 'agreement_no',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true,
                    sortable: false,

                },
                {
                    label: 'Unit Ownership',
                    field: 'ownership',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true

                },
                {
                    label: 'Unit Status',
                    field: 'vehicle_status',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions:{
                      filterDropdownItems: ['Active(A)','In Garage(I)','Sold(S)','Void(V)'],
                    }

                },


            ],
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'debt_note_unit_detail_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
    loadList: function(){
      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      $.ajax({
        url: process.env.ROOT_API + "/debt-note-unit-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action


        },
        success: function(data) {
          self.loading = false;
          console.log(data.content.row);
          if (data.status == "success") {

            console.log('success');
            if (self.action == "export" ||  self.action == "export_queue") {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

              self.action = "list";
              self.loadList();

            } else {
                 if (data.content.row != undefined) {
                  console.log("data.content.log");
                  self.rows = data.content.row;
                }

                self.totalRecords = data.content.totalRecords;
            }



          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'debt-note-unit-report');
        }
      });

    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/DebtNoteUnitDetailReport.vue